var map = {
	"./dashboard/items": 470,
	"./dashboard/items.json": 470,
	"./images/logo.png": 839,
	"./menu/sidebarmenu": 471,
	"./menu/sidebarmenu.json": 471,
	"./shared/portalConfiguration": 472,
	"./shared/portalConfiguration.json": 472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 349;